Ext.define('SA.model.System', {
    statics: {
        async initialize() {
            var system = await SA.Ajax.request({resource: 'system'});

            SA.System = new SA.model.System(system);
        }
    },

    constructor(data) {
        this.year = data.year;
    },

    getYear() {
        return this.year;
    }
});